export enum EGameStartedState {
    Waiting,
    Starting,
    Running,
    Ended
}
